import { Injectable } from '@angular/core';
import { BaseSiteService } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

declare const grecaptcha: any;

@Injectable({
  providedIn: 'root',
})

export class RecaptchaService {
  private recaptchaEnabled$ = new BehaviorSubject<boolean>(false);
  private siteKey: string | null = null;

  constructor(private baseSiteService: BaseSiteService) { }

  loadRecaptchaConfig(): Promise<void> {
    return new Promise((resolve) => {
      this.baseSiteService.get().pipe(take(1)).subscribe((baseSite: any) => {
        const enabled = !!baseSite?.captchaConfig?.enabled;
        this.siteKey = baseSite?.captchaConfig?.publicKey || null;
        //console.log(this.siteKey);
        this.recaptchaEnabled$.next(enabled);
        resolve();
      });
    });
  }

  isEnabled$(): Observable<boolean> {
    return this.recaptchaEnabled$.asObservable();
  }

  isEnabled(): boolean {
    return this.recaptchaEnabled$.getValue();
  }

  getSiteKey(): string | null {
    return this.siteKey;
  }

  async getEnterpriseToken(widgetId: number): Promise<{ token: string }> {
    const response = await grecaptcha.enterprise.getResponse(widgetId);
    //console.log(response)
    return response;
  }
}

/*
export class RecaptchaEnterpriseService {
  private recaptchaEnabled$ = new BehaviorSubject<boolean>(false);
  private siteKey: string | null = null;

  constructor(private baseSiteService: BaseSiteService) { }

  loadRecaptchaConfig(): Promise<void> {
    return new Promise((resolve) => {
      this.baseSiteService.get().pipe(take(1)).subscribe((baseSite: any) => {
        const enabled = !!baseSite?.captchaConfig?.enabled;
        this.siteKey = baseSite?.captchaConfig?.publicKey || null;
        this.recaptchaEnabled$.next(enabled);
        resolve();
      });
    });
  }

  isEnabled$(): Observable<boolean> {
    return this.recaptchaEnabled$.asObservable();
  }

  isEnabled(): boolean {
    return this.recaptchaEnabled$.getValue();
  }

  getSiteKey(): string | null {
    return this.siteKey;
  }

  async getToken(action: string): Promise<string> {
    return grecaptcha.enterprise.execute(this.siteKey, { action });
  }
} */
